import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { activeSchemaIdSelector } from '../../../redux/selectors/builder';
import usePermission from '../../../utils/hooks/permissionHooks/usePermission';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';
import PermissionElementWrapper from '../../../pages/PermissionControls/PermissionElementWrapper';
import ExecuteAction from './ExecuteAction';

interface IProps {
  onClick: () => void;
  loading: boolean;
  isGreyedOut: boolean;
}

const ExecuteReportAction = ({ onClick, loading, isGreyedOut }: IProps) => {
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const { checkIsPermitted } = usePermission();
  const isPermittedToExecuteAnalysis = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AnalysisCreate],
    schemaId: activeSchemaId,
  });

  return (
    <PermissionElementWrapper isPermitted={isPermittedToExecuteAnalysis}>
      <ExecuteAction
        onClick={onClick}
        disabled={loading || !isPermittedToExecuteAnalysis}
        isGreyedOut={isGreyedOut}
        label={'Execute'}
        trackContext="report"
        trackAction="execute"
      />
    </PermissionElementWrapper>
  );
};

export default ExecuteReportAction;
